export default "__VITE_ASSET__Bd5wNxz0__"